import { z } from "zod";
import { EventRolesSchema } from "../constants/event-role.constants.js";
import { UserIdPublicSchema } from "./branded-id.schemas.js";
import { EmailAddressSchema } from "./email.schemas.js";
import { UserIdentitySchema } from "./user-identity.schemas.js";

export const EventHostSchema = z.object({
  userIdPublic: UserIdPublicSchema,
  identity: UserIdentitySchema,
  email: EmailAddressSchema.nullable(),
  roles: EventRolesSchema,
  isCreator: z.boolean(),
});

export type EventHost = z.infer<typeof EventHostSchema>;

export const RemoveEventHostResultSchema = z
  .object({
    action: z.enum(["removed"]),
  })
  .readonly();

export type RemoveEventHostResult = z.infer<typeof RemoveEventHostResultSchema>;
